import { createRouter, createWebHashHistory } from 'vue-router'
import { sso } from "roboflex-thalamus-sso-lib";
import { consumiuReloadPorTrocaTenant } from "roboflex-thalamus-request-handler";

//Projetos
import ControleDeProjetos from '../views/Projetos/ControleDeProjetos.vue'
import ProjetoView from '../views/Projetos/ProjetoView'
import GestaoDeMudanca from '../views/Gestão/GestaoDeMudanca.vue'
import GestaoDeEntregas from '../views/Gestão/GestãoDeEntregas.vue'
import LogsProjeto from '../views/Gestão/LogsProjeto.vue'
import LancamentoDespesaProjeto from '../views/Gestão/LancamentoDespesaProjeto.vue'

//Plano de Ação (antigo)
import ControledePlanodeAção from '@/views/PA/ControleDePlanodeAção.vue'
import VisualizaçãoPlanodeAção from '@/views/PA/VisualizaçãoPlanodeAção.vue'

//PAP
import ControleDePAP from '@/views/PAP/ControleDePAP.vue'
import VisualizacaoPAP from '@/views/PAP/VisualizaçãoPAP.vue'

//Programas
import ControleProgramas from '@/views/Programas/ControleProgramas'

//Gestão
import GestaoDeTarefas from '@/views/Gestão/GestaoDeTarefas.vue';
import GestaoDeProjetos from '@/views/Gestão/GestaoDeProjetos.vue';
import DashboardProjetosAuditor from '@/views/Gestão/DashboardProjetosAuditor.vue';
import DocumentacaoPortfolioAuditor from '@/views/Gestão/DocumentacaoPortfolioAuditor.vue';
import PortfolioProjetosAuditor from '@/views/Gestão/PortfolioProjetosAuditor.vue';
import PortfolioProjetoDetalheAuditor from '@/views/Gestão/PortfolioProjetoDetalheAuditor.vue';
import GestaoDeIaView from '@/views/Gestão/GestaoDeIaView.vue';
import { getPermissao } from '@/services/permissao-service';
import { canAccessAiGovernance } from '@/utils/ai-governance';

//Protocolos
import CriarProtocolo from '@/views/Protocolo/CriarProtocolo.vue';
import VisualizacaoProtocolo from '@/views/Protocolo/VisualizaçãoProtocolo.vue';

//Rotina
import GruposGestao from '@/views/Rotina/GruposGestão.vue';
import GruposView from '@/views/Rotina/GruposView.vue';
import ControleDeProtocolo from '@/views/Protocolo/ControleDeProtocolo.vue';
import AgendaReunioes from '@/views/Reunioes/AgendaReunioes.vue';
import ReuniaoView from '@/views/Reunioes/ReuniãoView.vue';
import TemasTemporarios from '@/views/Reunioes/TemasTemporarios.vue';
import ViewTemaTemporario from '@/views/Reunioes/ViewTemaTemporario.vue';
import IndicadoresProjetos from '@/views/Projetos/IndicadoresProjetos.vue';

//OS Tablets
import ListagemOsTablets from '@/views/Protocolo/ListagemOsTablets.vue';
import VisualizacaoOsTablets from '@/views/Protocolo/VisualizacaoOsTablets.vue';
import ListaReunioes from '@/views/Reuniões_Google/ListaReunioes.vue';


function guardMyroute(to, from, next) {
  if (sso.validarSessao()) {
    next();
  } else {
    document.location = process.env.VUE_APP_ROOT_SSO_LOGIN;
  }
}

async function guardAuditor(to, from, next) {
  if (!sso.validarSessao()) {
    document.location = process.env.VUE_APP_ROOT_SSO_LOGIN;
    return;
  }
  try {
    const funcs = await getPermissao();
    if (funcs.includes(116)) {
      next();
    } else {
      next('/');
    }
  } catch (_) {
    next('/');
  }
}

async function guardGestaoIa(to, from, next) {
  if (!sso.validarSessao()) {
    document.location = process.env.VUE_APP_ROOT_SSO_LOGIN;
    return;
  }
  try {
    const funcs = await getPermissao();
    if (canAccessAiGovernance(funcs)) {
      next();
    } else {
      next('/');
    }
  } catch (_) {
    next('/');
  }
}

const routes = [
  {
    path: '/',
    name: 'gestaoTarefas',
    component: GestaoDeTarefas,
    beforeEnter: guardMyroute,
  },

  // Reuniões Google
  {
    path: '/reunioes-google',
    name: 'listaReunioes',
    component: ListaReunioes,
    beforeEnter: guardMyroute,
  },

  // Reunioes 
  {
    path: '/temas',
    name: 'temasTemporarios',
    component: TemasTemporarios,
    beforeEnter: guardMyroute,
  },

  {
    path: '/tema/:id',
    props: true,
    name: 'viewTemasTemporario',
    component: ViewTemaTemporario,
    beforeEnter: guardMyroute,
  },

  {
    path: '/agenda',
    name: 'agendaReunioesView',
    component: AgendaReunioes,
    beforeEnter: guardMyroute,
  },

  {
    path: '/reuniao/:id',
    props: true,
    name: 'reuniaoView',
    component: ReuniaoView,
    beforeEnter: guardMyroute,
  },

  //Rotina
  {
    path: '/rotina',
    name: 'gruposGestao',
    component: GruposGestao,
    beforeEnter: guardMyroute,
  },
  {
    path: '/grupo/:id',
    name: 'grupoView',
    component: GruposView,
    props: route => ({
      id: route.params.id
    }),
    beforeEnter: guardMyroute,
  },

  //Protocolos
  {
    path: '/protocolos/:tipo',
    name: 'controleDeProtocolo',
    props: true,
    component: ControleDeProtocolo,
    beforeEnter: guardMyroute,
  },
  {
    path: '/protocolo/:idProtocolo',
    props: true,
    name: 'visualizacaoProtocolo',
    component: VisualizacaoProtocolo,
    beforeEnter: guardMyroute,
  },
  {
    path: '/protocolo/criar/:tipo',
    name: 'criacaoProtocolo',
    props: true,
    component: CriarProtocolo,
    beforeEnter: guardMyroute,
  },

  // Protocolo tablets
  {
    path: '/os_tablets',
    name: 'listagemOsTablets',
    component: ListagemOsTablets,
    beforeEnter: guardMyroute,
  },
  {
    path: '/os_tablets/:id',
    name: 'visualizacaoOsTablets',
    props: true,
    component: VisualizacaoOsTablets,
    beforeEnter: guardMyroute,
  },

  // Gestão
  {
    path: '/gestao',
    name: 'gestaoProjetos',
    component: GestaoDeProjetos,
    beforeEnter: guardMyroute,
  },
  {
    path: '/gestao/dashboard-projetos',
    name: 'dashboardProjetosAuditor',
    component: DashboardProjetosAuditor,
    beforeEnter: guardAuditor,
  },
  {
    path: '/gestao/portfolio-projetos',
    name: 'portfolioProjetosAuditor',
    component: PortfolioProjetosAuditor,
    beforeEnter: guardAuditor,
  },
  {
    path: '/gestao/portfolio-projetos/:id',
    name: 'portfolioProjetoDetalheAuditor',
    props: true,
    component: PortfolioProjetoDetalheAuditor,
    beforeEnter: guardAuditor,
  },
  {
    path: '/gestao/portfolio-documentacao',
    name: 'documentacaoPortfolioAuditor',
    component: DocumentacaoPortfolioAuditor,
    beforeEnter: guardAuditor,
  },
  {
    path: '/gestao/ia',
    name: 'gestaoIa',
    component: GestaoDeIaView,
    beforeEnter: guardGestaoIa,
  },

  // Gestão de Mudanças
  {
    path: '/gestao-mudancas',
    name: 'gestaoDeMudancas',
    component: GestaoDeMudanca,
    beforeEnter: guardMyroute,
  },
  {
    path: '/gestao-logs-projeto',
    name: 'logsProjeto',
    component: LogsProjeto,
    beforeEnter: guardMyroute,
  },
  {
    path: '/gestao-despesas-projeto',
    name: 'lancamentoDespesaProjeto',
    component: LancamentoDespesaProjeto,
    beforeEnter: guardMyroute,
  },
  {
    path: '/gestao-entregas',
    name: 'gestaoDeEntregas',
    component: GestaoDeEntregas,
    beforeEnter: guardMyroute,
  },

  //Plano de Ação (antigo)
  {
    path: '/PA/Controle',
    name: 'ControlePA',
    component: ControledePlanodeAção,
    beforeEnter: guardMyroute,
  },
  {
    path: '/PA',
    name: 'PA',
    component: VisualizaçãoPlanodeAção,
    beforeEnter: guardMyroute,
  },

  //PAP
  {
    path: '/PAP',
    name: 'controlePAP',
    component: ControleDePAP,
    beforeEnter: guardMyroute,
  },
  {
    path: '/PAP/:idPAP',
    name: 'visualizacaoPAP',
    props: true,
    component: VisualizacaoPAP,
    beforeEnter: guardMyroute,
  },

  //Programas
  {
    path: '/Programas/controle',
    name: 'controleProgramas',
    component: ControleProgramas,
    beforeEnter: guardMyroute,
  },

  //Projetos
  {
    path: '/projeto/:idProjeto',
    name: 'projetoView',
    props: true,
    component: ProjetoView,
    beforeEnter: guardMyroute,
  },
  {
    path: '/projetos/:id',
    props: true,
    name: 'controleDeProjetos',
    component: ControleDeProjetos,
    beforeEnter: guardMyroute,
  },
  // Indicadores
  {
    path: '/indicadores',
    name: 'indicadoresProjetos',
    component: IndicadoresProjetos,
    beforeEnter: guardMyroute,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

/** Após reload por troca de tenant, evita ficar em rota de detalhe com id de outra empresa. */
router.beforeEach((to, _from, next) => {
  if (!consumiuReloadPorTrocaTenant()) {
    next();
    return;
  }
  if (to.name === 'projetoView') {
    next({ name: 'controleDeProjetos', params: { id: 0 } });
    return;
  }
  if (to.name === 'visualizacaoPAP') {
    next({ name: 'controlePAP' });
    return;
  }
  next();
});

export default router